<h2>Test Packages</h2>

<div class="test-package-container">
  <div *ngFor="let package of lesson?.testPackages" class="package">{{ package }}</div>
</div>

<button mat-flat-button (click)="onCopy()">Copy to clipboard</button>
